import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  //.comment-form
  commentFormClass: {
    display: 'flex',
    alignItems: 'flex-end',
    flexFlow: 'column',
    padding: '10px 0',
    position: 'relative',
  },
  //.comment-form .input-field
  commentFormInputFieldClass: {
    margin: '0 0 0 0',
    width: '100%',
  },

  labelContainerClass: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  inputPrefixClass: {
    display: 'flex',
    gap: '5px',
    padding: '5px',
  },
}));
